import { useContext, useState } from "react"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { Design } from 'src/model'
import { TxPinVerification, TxPinVerificationD2, TxPinVerificationD3 } from "src/component"


export const DisableCard: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const {info: {institutionData}} = useContext(AppInfoContext)

    async function handleSubmit() {
        notifier.show('Card Disabled', null, 'success')
        close()
    }

    return (
        <>
            { institutionData.design === Design.DESIGN_1 ?
                <TxPinVerification
                    close={close}
                    next={handleSubmit} 
                />
                : institutionData.design === Design.DESIGN_2 ?
                    <TxPinVerificationD2
                        close={close}
                        next={handleSubmit} 
                    />
                    :
                        <TxPinVerificationD3
                            close={close}
                            next={handleSubmit} 
                        />
            }
        </>
    )
}